module.exports = __webpack_public_path__ + "assets/word_mango.9d509bae.svg";